<!--
  --
  -- 日付入力カード
  --
  -->
<template>
  <v-card class="c-time-picker-card">
    <c-time-picker
      v-model="time"
      :min="min"
      :max="max"
      :allowed-times="allowedTimes"
      color="primary"
    />

    <v-card-actions>
      <v-spacer/>

      <v-btn
        text
        @click="onCancel"
      >
        <span>キャンセル</span>
      </v-btn>

      <v-btn
        text color="primary"
        @click="onOK"
        :disabled="!time"
      >
        <span>OK</span>
      </v-btn>
    </v-card-actions>
  </v-card>
</template>

<script>
import CTimePicker from '@/components/CTimePicker'

export default {
  name: 'CTimePickerCard',
  components: {
    CTimePicker
  },

  model: {
    prop: 'value',
    event: 'change'
  },

  props: {
    /**
     * 選択値 hh:mm
     */
    value: {
      type: String,
      required: true
    },

    /**
     * 表示開始時刻
     */
    min: {
      type: String,
      default: '00:00'
    },

    /**
     * 表示終了時刻
     */
    max: {
      type: String,
      default: '23:30'
    },

    /**
     * 時刻が選択可能かを判定する関数
     */
    allowedTimes: {
      type: Function,
      default: (value) => true
    }
  },

  data: () => ({
    time: ''
  }),

  created () {
    this.time = this.value
  },

  methods: {
    /**
     * キャンセル ボタン
     */
    onCancel () {
      this.time = this.value
      this.$emit('close')
    },

    /**
     * OK ボタン
     */
    onOK () {
      this.$emit('change', this.time)
      this.$emit('close')
    }
  }
}
</script>
